<div class="cpv-wrapper">
  <div class="top-back-btn-wrapper">
    <!-- Back Nav -->
    <button class="back-btn" (click)="goBack()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M19 12H5M12 19l-7-7 7-7" />
      </svg>
      Back to Candidates
    </button>
  </div>

  <div class="cpv-scrollable-content">
    <!-- Loading -->
    <div class="not-found-state" *ngIf="isLoading">
      <p>Loading candidate...</p>
    </div>

    <!-- Hero Banner Card (Full Width) -->
    <div class="hero-card" *ngIf="!isLoading && candidate">
      <div class="hero-top">
        <div class="avatar">{{ getInitials(candidateName) }}</div>
        <div class="hero-info">
          <div class="hero-name-row">
            <h1 class="hero-name expertise-text" [matTooltip]="candidateName">
              {{ candidateName }}
            </h1>
          </div>
          <p class="candidate-sub-info">
            Candidate profile · {{ jobCardVMs.length }} job application{{
              jobCardVMs.length === 1 ? "" : "s"
            }}
          </p>
        </div>
        <div class="hero-meta-right">
          <div class="meta-item">
            <span class="meta-lbl">EMAIL</span
            ><span
              class="meta-val expertise-text"
              [matTooltip]="candidateEmail"
              >{{ candidateEmail }}</span
            >
          </div>
          <div class="meta-item">
            <span class="meta-lbl">MOBILE</span
            ><span class="meta-val">{{ candidateMobile || "—" }}</span>
          </div>
          <div class="meta-item" *ngIf="candidate?.education">
            <span class="meta-lbl">EDUCATION</span
            ><span class="meta-val">{{ candidate?.education }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation Tabs -->
    <div class="candidate-tab-nav" *ngIf="!isLoading && candidate">
      <button
        class="tab-nav-btn"
        [class.active]="activeMainTab === 'job_applications'"
        (click)="activeMainTab = 'job_applications'"
      >
        Job Applications ({{ jobCardVMs.length }})
      </button>
      <button
        class="tab-nav-btn"
        [class.active]="activeMainTab === 'profile_details'"
        (click)="activeMainTab = 'profile_details'"
      >
        Profile Details
      </button>
    </div>

    <!-- JOB APPLICATIONS TAB VIEW -->
    <div
      class="job-applications-container"
      *ngIf="!isLoading && candidate && activeMainTab === 'job_applications'"
    >
      <div class="job-apps-header">
        <div class="header-titles">
          <h2>Job Applications</h2>
          <p>
            Assign a job from the button above, then manage its assessment and
            interview directly inside the job card.
          </p>
        </div>
        <div class="header-controls">
          <div class="search-wrap">
            <svg
              class="search-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              type="text"
              class="search-input"
              placeholder="Search jobs..."
              [(ngModel)]="jobSearchQuery"
            />
          </div>
          <select class="filter-select" [(ngModel)]="selectedJobFilter">
            <option value="all">All Jobs</option>
            <option value="assigned">Assigned</option>
            <option value="not_assigned">Not Assigned</option>
          </select>
          <select class="filter-select" [(ngModel)]="selectedStatusFilter">
            <option value="all">All Status</option>
            <option value="Selected">Selected</option>
            <option value="On Hold">On Hold</option>
            <option value="Rejected">Rejected</option>
          </select>

          <button class="btn-assign-job" (click)="openSelectJobModal()">
            + Assign Job
          </button>
        </div>
      </div>

      <!-- Job Cards List -->
      <div class="job-cards-list">
        <div class="empty-state-card" *ngIf="jobCardVMs.length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="margin-bottom: 1rem;">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
          </svg>
          <h3>No Job Applications Found</h3>
          <p>Assign a job to this candidate using the "+ Assign Job" button above.</p>
        </div>
        <div
          class="job-card"
          *ngFor="let job of jobCardVMs; let i = index; trackBy: trackByJobId"
        >
          <!-- Job Card Header -->
          <div class="job-card-header">
            <div class="job-header-left">
              <div class="job-icon-square">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                  <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                </svg>
              </div>
              <div class="job-title-info">
                <h3 class="job-title-name">{{ job.title }}</h3>
                <p class="job-subtitle-line">
                  {{ job.department }} &bull; Applied
                  {{ job.applied_date | date: "dd MMM yyyy" }}
                </p>
              </div>
            </div>
            <div class="job-header-right">
              <div class="status-badge-wrap">
                <span class="badge-lbl" style="text-align: center;">Default passing score</span>
                <span class="badge-pill pill-default"
                  >{{
                    job.default_passing_score !== undefined
                      ? job.default_passing_score
                      : 40
                  }}%</span
                >
              </div>
              <div class="status-badge-wrap">
                <span class="badge-lbl">System outcome</span>
                <span
                  class="badge-pill pill-outcome"
                  [ngClass]="job.system_outcome?.toLowerCase()"
                  >{{ job.system_outcome }}</span
                >
              </div>
              <div class="status-badge-wrap me-2">
                <span class="badge-lbl me-5">Final status</span>
                <div style="display: flex; align-items: center; gap: 6px">
                  <span
                    class="badge-pill pill-final"
                    [ngClass]="
                      job.final_status
                        ? 'pill-' +
                          job.final_status.toLowerCase().replace(' ', '_')
                        : ''
                    "
                    >{{ job.final_status }}</span
                  >
                  <span
                    class="updated-by-text"
                    *ngIf="job.final_status_updated_by_name"
                    style="font-size: 11px; color: #94a3b8; font-weight: 500"
                  >
                    By: {{ job.final_status_updated_by_name | titlecase }}
                  </span>
                </div>
              </div>
              <div class="status-dropdown-container">
                <button
                  class="btn-update-status-dropdown"
                  [disabled]="!canUpdateFinalStatus(job)"
                  [class.disabled-btn]="!canUpdateFinalStatus(job)"
                  (click)="toggleJobStatusDropdown(job.job_id, $event)"
                >
                  Update Status ▾
                </button>
                <div
                  class="status-dropdown-popover"
                  *ngIf="activeStatusDropdownJobId === job.job_id"
                  (click)="$event.stopPropagation()"
                >
                  <div class="dropdown-section-title">Final Decision</div>
                  <button
                    class="status-opt-btn"
                    [disabled]="isSystemOutcomeRejected(job)"
                    [class.disabled-opt]="isSystemOutcomeRejected(job)"
                    [title]="isSystemOutcomeRejected(job) ? 'Cannot mark as Selected when system outcome is Rejected' : ''"
                    (click)="!isSystemOutcomeRejected(job) && updateJobStatusQuick(job, 'selected')"
                  >
                    <span class="status-dot dot-selected"></span> Selected
                  </button>
                  <button
                    class="status-opt-btn"
                    (click)="updateJobStatusQuick(job, 'rejected')"
                  >
                    <span class="status-dot dot-rejected"></span> Rejected
                  </button>
                  <button
                    class="status-opt-btn"
                    (click)="updateJobStatusQuick(job, 'on_hold')"
                  >
                    <span class="status-dot dot-hold"></span> On Hold
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Job Card Body Grid -->
          <div class="job-card-body">
            <!-- Assessment Side (Left) -->
            <div class="job-side-col">
              <div class="col-header-row">
                <span class="col-heading">Assessment</span>
                <span
                  class="status-tag"
                  *ngIf="job.assessment"
                  [ngClass]="getAssessmentStatusClass(job.assessment, job)"
                >
                  {{ getAssessmentStatusText(job.assessment, job) }}
                </span>
                <span
                  class="status-tag tag-not-assigned"
                  *ngIf="!job.assessment"
                  >Not Assigned</span
                >
              </div>

              <div class="col-body-content">
                <!-- Assigned & Not Taken -->
                <ng-container
                  *ngIf="job.assessment && canChangeAssessment(job.assessment)"
                >
                  <div class="card-item-row">
                    <div class="item-left-group">
                      <div class="check-icon-circle">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6366f1"
                          stroke-width="2.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      </div>
                      <div class="item-text-details">
                        <h4 class="item-main-title">
                          {{
                            job.assessment.name ||
                              job.assessment.quiz_name ||
                              "Assessment"
                          }}
                        </h4>
                        <p class="item-sub-text">
                          Assigned · Candidate has not taken it yet
                        </p>
                        <button
                          class="btn-copy-link-text"
                          *ngIf="
                            job.assessment.url || job.assessment.assessment_url
                          "
                          (click)="
                            copyToClipboard(
                              job.assessment.url ||
                                job.assessment.assessment_url
                            )
                          "
                        >
                          Copy link
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                          >
                            <rect
                              x="9"
                              y="9"
                              width="13"
                              height="13"
                              rx="2"
                              ry="2"
                            />
                            <path
                              d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div class="item-actions">
                      <button
                        class="btn-change-outline"
                        *ngIf="canAssignOrChangeAnything(job)"
                        (click)="openSelectAssessmentModalForJob(job.job_id)"
                      >
                        Change
                      </button>
                      <button
                        class="btn-delete-trash"
                        *ngIf="canAssignOrChangeAnything(job)"
                        (click)="
                          deleteCandidateAssignment(
                            job.assessment.assignment_id
                          )
                        "
                        title="Delete Assessment"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#ef4444"
                          stroke-width="2"
                        >
                          <polyline points="3 6 5 6 21 6" />
                          <path
                            d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
                          />
                          <path d="M10 11v6" />
                          <path d="M14 11v6" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </ng-container>

                <!-- Completed / Passed / Failed Assessment -->
                <ng-container
                  *ngIf="job.assessment && !canChangeAssessment(job.assessment)"
                >
                  <div class="card-item-row completed-state">
                    <div class="progress-block">
                      <div class="score-row">
                        <span class="score-pct-bold"
                          >{{
                            job.assessment.score !== null &&
                            job.assessment.score !== undefined
                              ? job.assessment.score
                              : job.assessment.assessment_score || 0
                          }}%</span
                        >
                        <span class="pct-lbl">Completed</span>
                      </div>
                      <div class="progress-bar-track">
                        <div
                          class="progress-bar-fill"
                          [style.width.%]="
                            job.assessment.score ??
                            job.assessment.assessment_score ??
                            0
                          "
                        ></div>
                      </div>
                      <a
                        class="view-report-link"
                        (click)="goToAssessmentReport(job.assessment)"
                        >View Report</a
                      >
                    </div>
                    <div class="item-text-details flex-grow">
                      <h4 class="item-main-title">
                        {{ job.assessment.name || job.assessment.quiz_name }}
                      </h4>
                      <p class="item-sub-text">Submitted &amp; Graded</p>
                    </div>
                    <button
                      class="btn-delete-trash"
                      (click)="
                        deleteCandidateAssignment(job.assessment.assignment_id)
                      "
                      title="Delete Assessment"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ef4444"
                        stroke-width="2"
                      >
                        <polyline points="3 6 5 6 21 6" />
                        <path
                          d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
                        />
                        <path d="M10 11v6" />
                        <path d="M14 11v6" />
                      </svg>
                    </button>
                  </div>
                </ng-container>

                <!-- Not Assigned Assessment -->
                <ng-container *ngIf="!job.assessment">
                  <div class="unassigned-block">
                    <p class="unassigned-txt">Not assigned for this job</p>
                    <button
                      class="btn-purple-fill"
                      *ngIf="canAssignOrChangeAnything(job)"
                      (click)="openSelectAssessmentModalForJob(job.job_id)"
                    >
                      + Assign Assessment
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>

            <!-- AI Interview Side (Right) -->
            <div class="job-side-col">
              <div class="col-header-row">
                <span class="col-heading">AI Interview</span>
                <span
                  class="status-tag"
                  *ngIf="job.interview"
                  [ngClass]="getInterviewStatusClass(job.interview)"
                >
                  {{ getInterviewStatusText(job.interview) }}
                </span>
                <span class="status-tag tag-not-assigned" *ngIf="!job.interview"
                  >Not Assigned</span
                >
              </div>

              <div class="col-body-content">
                <!-- Assigned / Invited — Not Yet Taken -->
                <ng-container
                  *ngIf="
                    job.interview &&
                    (job.interview.status === 'invited' ||
                      job.interview.status === 'pending' ||
                      job.interview.status === 'not_started' ||
                      (!job.interview.ai_interview_score &&
                        job.interview.ai_interview_score !== 0))
                  "
                >
                  <div class="card-item-row">
                    <div class="item-left-group">
                      <div class="check-icon-circle">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#6366f1"
                          stroke-width="2.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      </div>
                      <div class="item-text-details">
                        <h4 class="item-main-title">
                          {{
                            job.interview.job_role ||
                              job.interview.name ||
                              "AI Interview"
                          }}
                        </h4>
                        <p class="item-sub-text">
                          Assigned · Candidate has not taken it yet
                        </p>
                        <button
                          class="btn-copy-link-text"
                          *ngIf="
                            job.interview.interview_url || job.interview.url
                          "
                          (click)="
                            copyToClipboard(
                              job.interview.interview_url || job.interview.url
                            )
                          "
                        >
                          Copy link
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                          >
                            <rect
                              x="9"
                              y="9"
                              width="13"
                              height="13"
                              rx="2"
                              ry="2"
                            />
                            <path
                              d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div class="item-actions">
                      <button
                        class="btn-change-outline"
                        *ngIf="canAssignOrChangeAnything(job)"
                        (click)="
                          openSelectAIInterviewModalForJobCard(job.job_id)
                        "
                      >
                        Change
                      </button>
                      <button
                        class="btn-delete-trash"
                        *ngIf="canAssignOrChangeAnything(job)"
                        (click)="
                          deleteCandidateInterview(job.interview.assignment_id)
                        "
                        title="Delete AI Interview"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#ef4444"
                          stroke-width="2"
                        >
                          <polyline points="3 6 5 6 21 6" />
                          <path
                            d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
                          />
                          <path d="M10 11v6" />
                          <path d="M14 11v6" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </ng-container>

                <!-- Completed / Evaluated Interview -->
                <ng-container
                  *ngIf="
                    job.interview &&
                    job.interview.status !== 'invited' &&
                    job.interview.status !== 'pending' &&
                    job.interview.status !== 'not_started' &&
                    job.interview.ai_interview_score !== null &&
                      job.interview.ai_interview_score !== undefined
                  "
                >
                  <div class="card-item-row completed-state">
                    <div class="progress-block">
                      <div class="score-row">
                        <span class="score-pct-bold"
                          >{{
                            job.interview.ai_interview_score !== null &&
                            job.interview.ai_interview_score !== undefined
                              ? job.interview.ai_interview_score
                              : job.interview.score || 0
                          }}%</span
                        >
                        <span class="pct-lbl">Completed</span>
                      </div>
                      <div class="progress-bar-track">
                        <div
                          class="progress-bar-fill"
                          [style.width.%]="
                            job.interview.ai_interview_score ??
                            job.interview.score ??
                            0
                          "
                        ></div>
                      </div>
                      <a
                        class="view-report-link"
                        (click)="goToAIInterviewReport(job.interview)"
                        >View Report</a
                      >
                    </div>
                    <div class="item-text-details flex-grow">
                      <h4 class="item-main-title">
                        {{
                          job.interview.job_role ||
                            job.interview.name ||
                            "AI Interview"
                        }}
                      </h4>
                      <p class="item-sub-text">Submitted &amp; Evaluated</p>
                    </div>
                    <button
                      class="btn-delete-trash"
                      (click)="
                        deleteCandidateInterview(job.interview.assignment_id)
                      "
                      title="Delete AI Interview"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#ef4444"
                        stroke-width="2"
                      >
                        <polyline points="3 6 5 6 21 6" />
                        <path
                          d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
                        />
                        <path d="M10 11v6" />
                        <path d="M14 11v6" />
                      </svg>
                    </button>
                  </div>
                </ng-container>

                <!-- Not Assigned AI Interview -->
                <ng-container *ngIf="!job.interview">
                  <div class="unassigned-block">
                    <p class="unassigned-txt">Not assigned for this job</p>
                    <button
                      class="btn-purple-fill"
                      *ngIf="canAssignOrChangeAnything(job)"
                      (click)="openSelectAIInterviewModalForJobCard(job.job_id)"
                    >
                      + Assign Interview
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Action Needed Warning Banner -->
          <div
            class="action-needed-banner"
            *ngIf="!job.assessment && !job.interview"
          >
            <svg
              class="warn-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="#f59e0b"
              stroke="#ffffff"
              stroke-width="2"
            >
              <path
                d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
              />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
            <span
              ><strong>Action needed:</strong> Assessment or AI Interview needs
              to be assigned for this job.</span
            >
          </div>
        </div>
      </div>
    </div>

    <!-- PROFILE DETAILS TAB VIEW -->
    <div
      class="profile-details-container"
      *ngIf="!isLoading && candidate && activeMainTab === 'profile_details'"
    >
      <div class="page-grid" [class.has-resume]="resumeUrl">
        <!-- LEFT COLUMN -->
        <div class="left-col">
          <!-- Profile Details Card -->
          <div class="info-card">
            <h3 class="section-title">Profile Details</h3>

            <div class="detail-grid">
              <div class="detail-entry">
                <span class="det-lbl">Email</span>
                <span
                  class="det-val expertise-text"
                  [matTooltip]="candidateEmail"
                  >{{ candidateEmail }}</span
                >
              </div>
              <div class="detail-entry">
                <span class="det-lbl">Mobile</span>
                <span class="det-val">{{ candidateMobile || "—" }}</span>
              </div>
              <div class="detail-entry">
                <span class="det-lbl">Current Location</span>
                <span
                  class="det-val expertise-text"
                  [matTooltip]="candidateLocation"
                  >{{ candidateLocation }}</span
                >
              </div>
              <ng-container *ngIf="candidate?.candidate_type === 'fresher'">
                <div class="detail-entry" *ngIf="candidate?.education">
                  <span class="det-lbl">Education</span>
                  <span class="det-val">{{ candidate?.education }}</span>
                </div>
                <div class="detail-entry" *ngIf="candidate?.cgpa">
                  <span class="det-lbl">CGPA</span>
                  <span class="det-val">{{ candidate?.cgpa }}</span>
                </div>
              </ng-container>
              <ng-container *ngIf="candidate?.candidate_type === 'experienced'">
                <div class="detail-entry">
                  <span class="det-lbl">Current Title</span>
                  <span
                    class="det-val expertise-text"
                    [matTooltip]="candidate.current_title"
                    >{{ candidate?.current_title || "—" }}</span
                  >
                </div>
                <div class="detail-entry">
                  <span class="det-lbl">Company</span>
                  <span
                    class="det-val expertise-text"
                    [matTooltip]="candidate.current_company"
                    >{{ candidate?.current_company || "—" }}</span
                  >
                </div>
                <div class="detail-entry">
                  <span class="det-lbl">Experience</span>
                  <span class="det-val">{{
                    candidate?.experience_years
                      ? candidate?.experience_years + " yrs"
                      : "—"
                  }}</span>
                </div>
                <div class="detail-entry">
                  <span class="det-lbl">Current CTC</span>
                  <span class="det-val"
                    >{{ candidate?.current_ctc || "—" }} L</span
                  >
                </div>
                <div class="detail-entry">
                  <span class="det-lbl">Expected CTC</span>
                  <span class="det-val"
                    >{{ candidate?.expected_ctc || "—" }} L</span
                  >
                </div>
              </ng-container>
              <ng-container *ngIf="candidate?.candidate_type === 'educator'">
                <div class="detail-entry">
                  <span class="det-lbl">Subject</span>
                  <span class="det-val">{{ candidate?.subject || "—" }}</span>
                </div>
                <div class="detail-entry">
                  <span class="det-lbl">Goal</span>
                  <span class="det-val">{{
                    candidate?.subject_specialization || "—"
                  }}</span>
                </div>
                <div class="detail-entry">
                  <span class="det-lbl">Experience</span>
                  <span class="det-val">{{
                    candidate?.experience_years
                      ? candidate?.experience_years + " yrs"
                      : "—"
                  }}</span>
                </div>
                <div class="detail-entry">
                  <span class="det-lbl">Previous Institute</span>
                  <span class="det-val">{{
                    candidate?.previous_institute || "—"
                  }}</span>
                </div>
                <div class="detail-entry">
                  <span class="det-lbl">Current CTC</span>
                  <span class="det-val"
                    >{{ candidate?.current_ctc || "—" }} L</span
                  >
                </div>
                <div class="detail-entry">
                  <span class="det-lbl">Expected CTC</span>
                  <span class="det-val"
                    >{{ candidate?.expected_ctc || "—" }} L</span
                  >
                </div>
              </ng-container>
            </div>

            <div
              class="skills-wrap"
              *ngIf="
                candidate?.skills?.length || candidate?.core_expertise?.length
              "
            >
              <h4 class="skills-heading">
                {{
                  candidate?.candidate_type === "experienced" &&
                  candidate?.core_expertise?.length
                    ? "Core Expertise"
                    : candidate?.skills?.length
                      ? "Skills"
                      : ""
                }}
              </h4>
              <div class="skills-row">
                <span
                  class="skill-tag"
                  *ngFor="
                    let s of candidate?.candidate_type === 'experienced'
                      ? candidate?.core_expertise || []
                      : candidate?.skills || []
                  "
                  >{{ s }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- Resume Card -->
        <div class="info-card resume-card" *ngIf="resumeUrl">
          <div class="resume-header">
            <h3 class="section-title mb0">Resume</h3>
            <button
              class="btn-outline-sm"
              *ngIf="resumeUrl"
              (click)="downloadResume(resumeUrl)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              Download
            </button>
          </div>
          <div
            class="resume-file-row"
            *ngIf="resumeUrl"
            (click)="downloadResume(resumeUrl)"
          >
            <div class="file-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#64748B"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
              </svg>
            </div>
            <div>
              <p class="file-name">Resume_{{ candidateName }}.pdf</p>
              <p class="file-hint">PDF · click download to view</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Report Tabs -->
    <!-- <div class="tab-bar">
    <button
      class="tab-btn"
      [class.active]="activeReportTab === 'Assessment'"
      (click)="activeReportTab = 'Assessment'"
    >
      Assessment Report
    </button>
    <button
      class="tab-btn"
      [class.active]="activeReportTab === 'Interview'"
      (click)="activeReportTab = 'Interview'"
    >
      AI Interview Report
    </button>
  </div> -->

    <!-- Assessment Report -->
    <!-- <div class="report-card" *ngIf="activeReportTab === 'Assessment'">
    <div class="report-header-row">
      <h3 class="section-title mb0">Test Results</h3>
      <span class="total-pct">{{ assessmentScore }}%</span>
    </div>
    <p class="empty-state-txt" *ngIf="!assessmentScore">
      No assessment results available yet.
    </p>
    <ng-container *ngIf="assessmentScore">
      <div class="bar-group">
        <div class="bar-label-row">
          <span>Overall</span><span class="bar-score">{{ assessmentScore }}%</span>
        </div>
        <div class="bar-track">
          <div class="bar-fill" [style.width.%]="assessmentScore"></div>
        </div>
      </div>
    </ng-container>
  </div> -->

    <!-- AI Interview Report -->
    <div class="report-card" *ngIf="activeReportTab === 'Interview'">
      <div class="report-header-row">
        <h3 class="section-title mb0">Interview Summary</h3>
        <span class="total-pct">{{ aiInterviewScore }}%</span>
      </div>
      <p class="empty-state-txt">
        Detailed AI interview feedback will appear here.
      </p>
    </div>

    <!--  -->
    <div class="not-found-state" *ngIf="!isLoading && !candidate">
      <p>Candidate not found.</p>
      <button class="back-btn" (click)="goBack()">Go Back</button>
    </div>
  </div>
  <!-- closes cpv-scrollable-content -->
</div>

<!-- =================== STATUS CONFIRM POPUP =================== -->
<!--<div class="status-modal-overlay" *ngIf="showConfirmPopup" (click)="cancelStatusUpdate()">
  <div class="status-modal-box fade-up" (click)="$event.stopPropagation()">
    <h2 class="status-modal-heading">
      Update status to "{{ selectedStatusToUpdate }}"?
    </h2>
    <p class="status-modal-body">
      The candidate's status will change from
      <strong>{{ displayStatus }}</strong> to
      <strong>{{ selectedStatusToUpdate }}</strong
      >. This action will be recorded in the activity log.
    </p>
    <div class="status-modal-actions">
      <button class="status-btn-cancel" (click)="cancelStatusUpdate()">
        Cancel
      </button>
      <button
        class="status-btn-confirm"
        (click)="confirmStatusUpdate()"
        [disabled]="isUpdatingStatus"
      >
        {{ isUpdatingStatus ? "Updating..." : "Confirm Update" }}
      </button>
    </div>
  </div>
</div>-->

<!-- =================== DELETE CONFIRM POPUP =================== -->
<div
  class="status-modal-overlay"
  *ngIf="showDeleteConfirmPopup"
  (click)="cancelDelete()"
>
  <div class="status-modal-box fade-up" (click)="$event.stopPropagation()">
    <h2 class="status-modal-heading">
      Delete
      {{ itemToDelete?.type === "interview" ? "AI Interview" : "Assessment" }}?
    </h2>
    <p class="status-modal-body">
      Are you sure you want to delete this
      {{
        itemToDelete?.type === "interview"
          ? "assigned AI interview"
          : "assigned assessment"
      }}? This action cannot be undone.
    </p>
    <div class="status-modal-actions">
      <button class="status-btn-cancel" (click)="cancelDelete()">Cancel</button>
      <button
        class="status-btn-confirm"
        style="background: #ef4444; color: white"
        (click)="confirmDelete()"
        [disabled]="isDeletingInterview || isDeletingAssignment"
      >
        <span
          *ngIf="isDeletingInterview || isDeletingAssignment"
          class="spinner-border spinner-border-sm me-1"
        ></span>
        {{
          isDeletingInterview || isDeletingAssignment ? "Deleting..." : "Delete"
        }}
      </button>
    </div>
  </div>
</div>

<!-- Select Assessment Modal (Step 1 — pick quiz) -->
<div class="modal-backdrop-blur" *ngIf="isSelectAssessmentModalOpen">
  <div class="modal-window-card lg">
    <div class="modal-header-row bg-purple-gradient">
      <div class="d-flex gap-3 align-items-center text-white">
        <div class="icon-box-white lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            />
            <polyline points="14 2 14 8 20 8" />
            <polyline points="9 15 11 17 15 13" />
          </svg>
        </div>
        <div>
          <h2 class="modal-title text-white">Select Assessment</h2>
          <p class="modal-subtitle text-white-70">
            Choose from published & active assessments.
          </p>
        </div>
      </div>
      <button
        class="modal-close-btn text-white-50"
        (click)="closeSelectAssessmentModal()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <div class="modal-body p-4">
      <div class="table-container scrollable mt-2">
        <div *ngIf="isLoadingAssessments" class="empty-state-cell">
          Loading assessments...
        </div>
        <table class="table custom-table" *ngIf="!isLoadingAssessments">
          <thead>
            <tr>
              <th></th>
              <th>ASSESSMENT</th>
              <th>JOB</th>
              <th>STATUS</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let q of availableAssessments"
              [hidden]="
                q.status &&
                q.status?.toLowerCase() !== 'published' &&
                q.status?.toLowerCase() !== 'active'
              "
              [class.selected-row]="selectedQuizId === (q.quiz_id ?? q._id)"
              (click)="selectedQuizId = q.quiz_id ?? q._id"
            >
              <td>
                <input
                  type="radio"
                  name="assessment"
                  class="custom-radio"
                  [checked]="selectedQuizId === (q.quiz_id ?? q._id)"
                  (change)="selectedQuizId = q.quiz_id ?? q._id"
                />
              </td>
              <td class="font-semibold">
                {{ q.quiz_name ?? q.title ?? "—" }}
              </td>
              <td>
                <span class="font-semibold">{{ q.job_title || "—" }}</span>
              </td>
              <td>
                <span class="badge-status-active">{{
                  q.status || "Published"
                }}</span>
              </td>
            </tr>
            <tr *ngIf="availableAssessments.length === 0">
              <td colspan="5" class="empty-state-cell">
                No assessments found.
              </td>
            </tr>
            <tr *ngIf="availableAssessments.length > 0 && !hasActiveQuiz">
              <td colspan="5" class="empty-state-cell">
                No active links available for this assessment.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer-row justify-content-end">
      <div class="d-flex gap-3">
        <button
          class="btn-text fw-bold text-dark"
          (click)="closeSelectAssessmentModal()"
        >
          Cancel
        </button>
        <button
          class="btn-primary-purple"
          [disabled]="!selectedQuizId"
          (click)="openSelectLinkModal(selectedQuizId)"
        >
          Next
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Select Assessment Link Modal (Step 2 — pick link) -->
<div class="modal-backdrop-blur" *ngIf="isSelectLinkModalOpen">
  <div class="modal-window-card lg">
    <div class="modal-header-row bg-purple-gradient">
      <div class="d-flex gap-3 align-items-center text-white">
        <div class="icon-box-white lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            />
            <polyline points="14 2 14 8 20 8" />
            <polyline points="9 15 11 17 15 13" />
          </svg>
        </div>
        <div>
          <h2 class="modal-title text-white">Select Assessment Link</h2>
          <p class="modal-subtitle text-white-70">
            Pick an active link for the selected assessment.
          </p>
        </div>
      </div>
      <button
        class="modal-close-btn text-white-50"
        (click)="closeSelectLinkModal()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <div class="modal-body p-4">
      <div class="table-container scrollable">
        <div *ngIf="isLoadingLinks" class="empty-state-cell">
          Loading links...
        </div>
        <table class="table custom-table" *ngIf="!isLoadingLinks">
          <thead>
            <tr>
              <th></th>
              <th>LINK NAME</th>
              <th>QUESTION</th>
              <th>EXPIRY</th>
              <th>STATUS</th>
              <th>URL</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let l of availableLinks"
              [hidden]="l.status && l.status?.toLowerCase() !== 'active'"
              [class.selected-row]="selectedAssessment?.link_id === l.link_id"
              [class.disabled-row]="isLinkAlreadyAssigned(l.link_id)"
              (click)="
                !isLinkAlreadyAssigned(l.link_id) && (selectedAssessment = l)
              "
            >
              <td>
                <input
                  type="radio"
                  name="link"
                  [checked]="selectedAssessment?.link_id === l.link_id"
                  [disabled]="isLinkAlreadyAssigned(l.link_id)"
                  (change)="selectedAssessment = l"
                />
              </td>
              <td class="font-semibold">{{ l.link_name || "—" }}</td>
              <td>{{ l.questions_per_quiz || 0 }} Q</td>
              <td>{{ getDuration(l.time_limit) }}</td>
              <td>
                <span class="badge-status-active">Active</span>
              </td>
              <td class="url-text-sm">{{ l.link_url ?? l.url ?? "—" }}</td>
            </tr>
            <tr *ngIf="availableLinks.length === 0">
              <td colspan="5" class="empty-state-cell">
                No links found for this assessment.
              </td>
            </tr>
            <tr *ngIf="availableLinks.length > 0 && !hasActiveLinks">
              <td colspan="5" class="empty-state-cell">
                No active links available for this assessment.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer-row justify-content-between">
      <button
        class="btn-text fw-bold text-dark"
        (click)="openSelectAssessmentModal()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
        >
          <line x1="19" y1="12" x2="5" y2="12" />
          <polyline points="12 19 5 12 12 5" />
        </svg>
        Back
      </button>
      <div class="d-flex gap-3">
        <button
          class="btn-outline-secondary border-0 text-dark fw-bold"
          (click)="closeSelectLinkModal()"
        >
          Cancel
        </button>
        <button
          class="btn-primary-purple"
          [disabled]="!selectedAssessment || isAssigning"
          (click)="openAssessmentSubmitDialogBox()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
          {{ isAssigning ? "Assigning..." : "Assign to Candidate" }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Select Job Modal -->
<div class="modal-backdrop-blur" *ngIf="isSelectJobModalOpen">
  <div class="modal-window-card lg">
    <div class="modal-header-row bg-purple-gradient">
      <div class="d-flex gap-3 align-items-center text-white">
        <div class="icon-box-white lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 2a10 10 0 1 0 10 10H12V2z" />
            <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
          </svg>
        </div>
        <div>
          <h2 class="modal-title text-white">Assign Job</h2>
          <p class="modal-subtitle text-white-70">
            Select a published job posting to assign to this candidate.
          </p>
        </div>
      </div>
      <button
        class="modal-close-btn text-white-50"
        (click)="closeSelectJobModal()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <div class="modal-body p-4">
      <div class="table-container scrollable mt-2">
        <div *ngIf="isLoadingJobs" class="empty-state-cell">
          Loading jobs...
        </div>
        <table class="table custom-table" *ngIf="!isLoadingJobs">
          <thead>
            <tr>
              <th></th>
              <th>JOB</th>
              <th>STATUS</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let j of availableJobs"
              [class.selected-row]="selectedJobForInterviewId === j.job_id"
              (click)="selectJobForInterview(j)"
            >
              <td>
                <input
                  type="radio"
                  name="jobSelection"
                  class="custom-radio"
                  [checked]="selectedJobForInterviewId === j.job_id"
                  (change)="selectJobForInterview(j)"
                />
              </td>
              <td class="font-semibold">
                {{ j.job_title || "—" }}
              </td>
              <td>
                <span class="badge-status-active">Published</span>
              </td>
            </tr>
            <tr *ngIf="availableJobs.length === 0">
              <td colspan="3" class="empty-state-cell">No jobs found.</td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination controls -->
        <div
          class="d-flex justify-content-between align-items-center mt-3"
          *ngIf="jobTotalPages > 1"
        >
          <button
            class="btn-outline-secondary"
            style="padding: 4px 12px; font-size: 0.85rem"
            [disabled]="jobCurrentPage === 1"
            (click)="onJobPageChange(jobCurrentPage - 1)"
          >
            Previous
          </button>
          <span style="font-size: 0.85rem; color: #64748b; font-weight: 500"
            >Page {{ jobCurrentPage }} of {{ jobTotalPages }}</span
          >
          <button
            class="btn-outline-secondary"
            style="padding: 4px 12px; font-size: 0.85rem"
            [disabled]="jobCurrentPage === jobTotalPages"
            (click)="onJobPageChange(jobCurrentPage + 1)"
          >
            Next
          </button>
        </div>
      </div>
    </div>

    <div class="modal-footer-row justify-content-end">
      <div class="d-flex gap-3">
        <button
          class="btn-text fw-bold text-dark"
          (click)="closeSelectJobModal()"
        >
          Cancel
        </button>
        <button
          class="btn-primary-purple"
          [disabled]="!selectedJobForInterviewId || isAssigningJob"
          (click)="confirmAssignJobToCandidate()"
        >
          {{ isAssigningJob ? "Assigning..." : "Assign Job" }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Select AI Interview Modal (single step — pick screening round) -->
<div class="modal-backdrop-blur" *ngIf="isSelectAIInterviewModalOpen">
  <div class="modal-window-card lg">
    <div class="modal-header-row bg-purple-gradient">
      <div class="d-flex gap-3 align-items-center text-white">
        <div class="icon-box-white lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 2a10 10 0 1 0 10 10H12V2z" />
            <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
          </svg>
        </div>
        <div>
          <h2 class="modal-title text-white">Select AI Interview</h2>
          <p class="modal-subtitle text-white-70">
            Choose a screening round to assign to this candidate.
          </p>
        </div>
      </div>
      <button
        class="modal-close-btn text-white-50"
        (click)="closeSelectAIInterviewModal()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>

    <div class="modal-body p-4">
      <div class="table-container scrollable mt-2">
        <div *ngIf="isLoadingRounds" class="empty-state-cell">
          Loading screening rounds...
        </div>
        <table class="table custom-table" *ngIf="!isLoadingRounds">
          <thead>
            <tr>
              <th>INTERVIEW</th>
              <th>LINK</th>
              <th>JOB</th>
              <th>DURATION</th>
              <th>EXPIRY DATE</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let r of availableRounds"
              [hidden]="isRoundExpired(r)"
              [class.selected-row]="selectedRoundId === r.id"
              [class.disabled-row]="isRoundAlreadyAssigned(r)"
              (click)="!isRoundAlreadyAssigned(r) && selectRound(r)"
            >
              <td class="font-semibold">
                {{ r.job_role ?? "—" }}
              </td>
              <td>
                <div class="d-flex align-items-center gap-2">
                  <span
                    class="url-text-sm text-muted"
                    [title]="r.interview_url || ''"
                    style="font-size: 0.8rem"
                  >
                    {{
                      r.interview_url
                        ? (r.interview_url | slice: 0 : 20) +
                          (r.interview_url.length > 20 ? "..." : "")
                        : "—"
                    }}
                  </span>
                  <button
                    class="btn btn-sm p-1 border-0 bg-transparent"
                    (click)="
                      copyToClipboard(r.interview_url); $event.stopPropagation()
                    "
                    *ngIf="r.interview_url"
                    title="Copy Link"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <rect
                        x="9"
                        y="9"
                        width="13"
                        height="13"
                        rx="2"
                        ry="2"
                      ></rect>
                      <path
                        d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                      ></path>
                    </svg>
                  </button>
                </div>
              </td>
              <td>{{ r.job_title ?? r.department ?? "—" }}</td>
              <td>
                {{
                  r.total_duration_minutes
                    ? r.total_duration_minutes + " min"
                    : "—"
                }}
              </td>
              <td>
                {{ r.valid_until ? (r.valid_until | date: "yyyy-MM-dd") : "—" }}
              </td>
              <td>
                <button
                  class="btn btn-sm"
                  [disabled]="isRoundAlreadyAssigned(r)"
                  style="
                    border-radius: 6px;
                    padding: 4px 12px;
                    font-weight: 500;
                  "
                  [ngStyle]="
                    selectedRoundId === r.id
                      ? {
                          'background-color': '#eef2ff',
                          color: '#4f46e5',
                          border: '1px solid #4f46e5',
                        }
                      : isRoundAlreadyAssigned(r)
                        ? {
                            'background-color': '#f1f5f9',
                            color: '#94a3b8',
                            border: '1px solid #cbd5e1',
                            cursor: 'not-allowed',
                          }
                        : {
                            'background-color': '#fff',
                            color: '#64748b',
                            border: '1px solid #cbd5e1',
                          }
                  "
                  (click)="
                    !isRoundAlreadyAssigned(r) && selectRound(r);
                    $event.stopPropagation()
                  "
                >
                  {{
                    isRoundAlreadyAssigned(r)
                      ? "Assigned"
                      : selectedRoundId === r.id
                        ? "Selected"
                        : "Select"
                  }}
                </button>
              </td>
            </tr>
            <tr *ngIf="availableRounds.length === 0">
              <td colspan="6" class="empty-state-cell">
                No screening rounds found.
              </td>
            </tr>
            <tr *ngIf="availableRounds.length > 0 && !hasActiveRounds">
              <td colspan="6" class="empty-state-cell">
                No active links available for this AI interview.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Controls -->
      <div
        class="pagination-container"
        *ngIf="availableRounds.length > 0 && aiInterviewTotalPages > 1"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 1rem;
          margin-top: 1rem;
        "
      >
        <button
          class="secondary-action-btn"
          style="
            padding: 0.5rem 1rem;
            border-radius: 6px;
            border: 1px solid #e2e8f0;
            background: #fff;
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          "
          [disabled]="!aiInterviewHasPreviousPage"
          [ngStyle]="{
            opacity: !aiInterviewHasPreviousPage ? '0.5' : '1',
            cursor: !aiInterviewHasPreviousPage ? 'not-allowed' : 'pointer',
          }"
          (click)="onAIInterviewPageChange(aiInterviewCurrentPage - 1)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
          Previous
        </button>

        <span style="font-size: 0.875rem; color: #475569; font-weight: 500">
          Page {{ aiInterviewCurrentPage }} of {{ aiInterviewTotalPages }}
        </span>

        <button
          class="secondary-action-btn"
          style="
            padding: 0.5rem 1rem;
            border-radius: 6px;
            border: 1px solid #e2e8f0;
            background: #fff;
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          "
          [disabled]="!aiInterviewHasNextPage"
          [ngStyle]="{
            opacity: !aiInterviewHasNextPage ? '0.5' : '1',
            cursor: !aiInterviewHasNextPage ? 'not-allowed' : 'pointer',
          }"
          (click)="onAIInterviewPageChange(aiInterviewCurrentPage + 1)"
        >
          Next
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
    </div>

    <div class="modal-footer-row justify-content-end">
      <div class="d-flex gap-3">
        <button
          class="btn-text fw-bold text-dark"
          (click)="closeSelectAIInterviewModal()"
        >
          Cancel
        </button>
        <button
          class="btn-primary-purple"
          [disabled]="!selectedRoundId"
          (click)="openSendInvitationPopup()"
        >
          Assign to Candidate
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal-overlay"
  *ngIf="showSendInvitationPopup"
  (click)="closeSendInvitationPopup()"
  style="z-index: 9999; background: rgba(0, 0, 0, 0.5)"
>
  <div
    class="modal-box fade-up p-0"
    style="
      max-width: 500px;
      border-radius: 12px;
      overflow: hidden;
      background-color: #ffffff;
    "
    (click)="$event.stopPropagation()"
  >
    <div class="p-4">
      <div class="d-flex align-items-center gap-2 mb-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#4f46e5"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
        <h2
          class="m-0"
          style="font-size: 1.125rem; font-weight: 600; color: #1e293b"
        >
          Send {{ selectedAIRoundDetails?.job_role || "Interview" }} Invitation
        </h2>
      </div>

      <p
        style="
          font-size: 0.875rem;
          color: #475569;
          line-height: 1.5;
          margin-bottom: 1.5rem;
        "
      >
        Are you sure you want to send the invitation to
        <strong>{{ candidateName || "the candidate" }}</strong
        >? An email containing the AI interview details and access instructions
        will be sent to the candidate at
        <strong>{{ candidateEmail || "their email" }}</strong
        >.
      </p>

      <div
        class="p-3 rounded-3 mb-4"
        style="background-color: #f8fafc; border: 1px solid #e2e8f0"
      >
        <div class="d-flex justify-content-between mb-2">
          <span style="font-size: 0.875rem; color: #64748b">AI Interview</span>
          <span style="font-size: 0.875rem; font-weight: 500; color: #1e293b">{{
            selectedAIRoundDetails?.job_role ?? "—"
          }}</span>
        </div>
        <div class="d-flex justify-content-between mb-2">
          <span style="font-size: 0.875rem; color: #64748b">Duration</span>
          <span style="font-size: 0.875rem; font-weight: 500; color: #1e293b">{{
            selectedAIRoundDetails?.total_duration_minutes
              ? selectedAIRoundDetails?.total_duration_minutes + " min"
              : "—"
          }}</span>
        </div>
        <div class="d-flex justify-content-between">
          <span style="font-size: 0.875rem; color: #64748b">Expiry</span>
          <span style="font-size: 0.875rem; font-weight: 500; color: #1e293b">{{
            selectedAIRoundDetails?.valid_until
              ? (selectedAIRoundDetails?.valid_until | date: "MMM dd, yyyy")
              : "—"
          }}</span>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-3">
        <button
          class="btn btn-outline-secondary"
          style="
            border-radius: 6px;
            padding: 8px 20px;
            font-weight: 500;
            border: 1px solid #e2e8f0;
            background: #fff;
            color: #1e293b;
          "
          (click)="closeSendInvitationPopup()"
        >
          Cancel
        </button>
        <button
          class="btn btn-primary-purple d-flex align-items-center gap-2"
          style="border-radius: 6px; padding: 8px 20px; font-weight: 500"
          [disabled]="isAssigning"
          (click)="confirmAssignAIInterview()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="22" y1="2" x2="11" y2="13"></line>
            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
          </svg>
          {{ isAssigning ? "Sending..." : "Send Invitation" }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Report Warning Popup -->
<div
  class="report-warning-overlay"
  *ngIf="showReportWarningPopup"
  (click)="closeReportWarning()"
>
  <div class="report-warning-box" (click)="$event.stopPropagation()">
    <div class="report-warning-header">
      <h4>{{ reportWarningTitle }}</h4>
      <button class="close-btn" (click)="closeReportWarning()">✕</button>
    </div>
    <div class="report-warning-body">
      <div
        class="icon-wrapper"
        [ngClass]="reportWarningType === 'error' ? 'error' : 'info'"
      >
        <i
          class="bi"
          [ngClass]="
            reportWarningType === 'error'
              ? 'bi-exclamation-circle-fill'
              : 'bi-info-circle-fill'
          "
        ></i>
      </div>
      <p>
        {{ reportWarningMessage }}
      </p>
    </div>
    <div class="report-warning-footer">
      <button class="btn-okay" (click)="closeReportWarning()">Okay</button>
    </div>
  </div>
</div>

<!-- VIEW LOGS MODAL -->
<div
  class="modal-backdrop-blur fade-up"
  *ngIf="showLogsModal"
  style="z-index: 2100"
>
  <div class="logs-modal-box">
    <div class="logs-modal-header">
      <div>
        <h4>Activity & Status Logs</h4>
        <p class="logs-modal-subtitle">
          Logs for
          {{
            selectedItemForLogs?.quiz_name ||
              selectedItemForLogs?.job_role ||
              "Item"
          }}
        </p>
      </div>
      <button class="close-btn" (click)="closeLogsModal()">✕</button>
    </div>
    <div class="logs-modal-body">
      <div
        class="timeline-container"
        *ngIf="
          getItemLogs(selectedItemForLogs?.assignment_id)?.length;
          else noLogs
        "
      >
        <div
          class="timeline-item"
          *ngFor="let log of getItemLogs(selectedItemForLogs?.assignment_id)"
        >
          <div class="timeline-badge-line"></div>
          <div class="timeline-content">
            <div class="timeline-header">
              <span
                class="pill pill-sm"
                [ngClass]="getStatusBadgeClass(log.status)"
                >{{ log.status }}</span
              >
              <span class="timeline-time">{{
                log.timestamp | date: "d MMM yyyy, h:mm a"
              }}</span>
            </div>
            <p class="timeline-comment">{{ log.comment }}</p>
          </div>
        </div>
      </div>
      <ng-template #noLogs>
        <div class="no-logs-state">
          <i class="bi bi-journal-text"></i>
          <p>No activity logs found for this item.</p>
        </div>
      </ng-template>
    </div>
    <div class="logs-modal-footer">
      <button class="status-btn-cancel" (click)="closeLogsModal()">
        Close
      </button>
    </div>
  </div>
</div>

<!-- UPDATE STATUS MODAL (ASSESSMENT / INTERVIEW) -->
<div
  class="modal-backdrop-blur fade-up"
  *ngIf="showUpdateStatusModal"
  style="z-index: 2100"
>
  <div class="logs-modal-box">
    <div class="logs-modal-header">
      <div>
        <h4>Update Status</h4>
        <p class="logs-modal-subtitle">
          Update status and logs for:
          {{
            selectedItemForUpdate?.title ||
              selectedItemForUpdate?.job_title ||
              selectedItemForUpdate?.quiz_name ||
              selectedItemForUpdate?.job_role ||
              "Job Application"
          }}
        </p>
      </div>
      <button class="close-btn" (click)="closeUpdateStatusModal()">✕</button>
    </div>
    <div class="logs-modal-body">
      <div class="mb-4">
        <label
          class="form-label"
          style="
            display: block;
            font-size: 0.85rem;
            color: #475569;
            margin-bottom: 0.5rem;
            font-weight: 600;
          "
          >Select Status</label
        >
        <div class="select-wrap" style="position: relative; width: 100%">
          <select
            class="status-select"
            [(ngModel)]="newUpdateStatus"
            style="
              width: 100%;
              border: 1px solid #cbd5e1;
              border-radius: 0.5rem;
              padding: 0.625rem 1rem;
              font-size: 0.85rem;
              appearance: none;
              -webkit-appearance: none;
              outline: none;
              background-image: url('data:image/svg+xml;utf8,<svg xmlns=&quot;http://www.w3.org/2000/svg&quot; width=&quot;24&quot; height=&quot;24&quot; viewBox=&quot;0 0 24 24&quot; fill=&quot;none&quot; stroke=&quot;%2364748B&quot; stroke-width=&quot;2&quot; stroke-linecap=&quot;round&quot; stroke-linejoin=&quot;round&quot;><polyline points=&quot;6 9 12 15 18 9&quot;></polyline></svg>');
              background-repeat: no-repeat;
              background-position: right 1rem center;
              background-size: 1rem;
            "
          >
            <option value="Selected">Selected</option>
            <option value="Rejected">Rejected</option>
            <option value="On Hold">On Hold</option>
            <option value="Shortlisted">Shortlisted</option>
            <option value="Interview Scheduled">Interview Scheduled</option>
            <option value="Applied">Applied</option>
            <option value="Assessment Pending">Assessment Pending</option>
            <option value="Assessment Completed">Assessment Completed</option>
          </select>
        </div>
      </div>

      <div class="mb-3">
        <label
          class="form-label"
          style="
            display: block;
            font-size: 0.85rem;
            color: #475569;
            margin-bottom: 0.5rem;
            font-weight: 600;
          "
          >Add Note / Comment</label
        >
        <textarea
          class="comment-textarea"
          rows="4"
          placeholder="Type a note about this status update..."
          [(ngModel)]="newUpdateComment"
          style="
            width: 100%;
            border: 1px solid #cbd5e1;
            border-radius: 0.5rem;
            padding: 0.75rem 1rem;
            font-size: 0.85rem;
            outline: none;
            resize: vertical;
            box-sizing: border-box;
          "
        ></textarea>
      </div>
    </div>
    <div class="logs-modal-footer" style="display: flex; gap: 0.75rem">
      <button class="status-btn-cancel" (click)="closeUpdateStatusModal()">
        Cancel
      </button>
      <button
        class="btn-send"
        (click)="submitItemStatusUpdate()"
        style="
          background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%);
          border: none;
          border-radius: 0.5rem;
          padding: 0.625rem 1.25rem;
          font-size: 0.85rem;
          font-weight: 600;
          color: #ffffff;
          cursor: pointer;
          box-shadow: 0 4px 12px rgba(124, 58, 237, 0.15);
          transition: all 0.2s;
        "
      >
        Save Changes
      </button>
    </div>
  </div>
</div>

<!-- =================== TOAST NOTIFICATION =================== -->
<div class="toast" [class.toast-show]="showToast">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
  Comment added to activity log
</div>
<!-- </div> -->
